import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const LockSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#343330",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M7.37464 22H16.6254C18.2041 22 19 21.1979 19 19.5032V12.6856C19 11.0039 18.2041 10.2018 16.6254 10.2018H7.37464C5.79589 10.2018 5 11.0039 5 12.6856V19.5032C5 21.1979 5.79589 22 7.37464 22ZM7.45294 20.2665C7.0876 20.2665 6.87883 20.0595 6.87883 19.6326V12.5563C6.87883 12.1294 7.0876 11.9353 7.45294 11.9353H16.5471C16.9254 11.9353 17.1211 12.1294 17.1211 12.5563V19.6326C17.1211 20.0595 16.9254 20.2665 16.5471 20.2665H7.45294ZM6.77446 11.0944H8.61417V7.47219C8.61417 4.96247 10.2451 3.73351 11.9935 3.73351C13.7549 3.73351 15.3989 4.96247 15.3989 7.47219V11.0944H17.2386V7.74386C17.2386 3.7723 14.616 2 11.9935 2C9.38396 2 6.77446 3.7723 6.77446 7.74386V11.0944Z"
        fill={color}
      />
    </svg>
  );
};

export { LockSvg };
